<script lang="ts" setup>
import {
  STATE_CONTENT_ADDRESS_SYSTEM,
  STATE_DIALOG_ADDRESS_SYSTEM,
} from '@/constants/statesOfAddressSystem'

import { useAddressSystemDialog } from '@/composables/address-system/useAddressSystemDialog'

import AddressSystemDelivery from '@/components/AddressSystem/AddressSystemDelivery.vue'
import AddressSystemMap from '@/components/AddressSystem/map/AddressSystemMap.vue'
import DialogRedirectOtherCity from '@/components/Basket/dialogs/DialogRedirectOtherCity.vue'

const AddressSystemDialogError = defineAsyncComponent(
  () => import('@/components/AddressSystem/AddressSystemDialogError.vue'),
)

type Props = { modelValue: boolean }

const emit = defineEmits(['update:modelValue'])

defineProps<Props>()

const { $metrics } = useNuxtApp()

// Включает mounted и unmounted
const {
  deliveryBasket,
  deliveryBasketId,
  refuseChangeOnOtherCity,
  stateDialogContent,
  onChangeBasketAddress,
  onChangeDialogModelValue,
  dialogState,
  isVisibleContent,
  fetchPoint,
  initBasketDelivery,
  setInitStateOfDialog,
  resetDialogState,
  setSelectedRestaurant,
  initAddressStorageInDeliveryAddress,
} = useAddressSystemDialog(emit)

const changeDialogModelValue = (value: boolean) => {
  if (!value) $metrics?.eventSendGoal({ ym: 'address_window_closed' })
  onChangeDialogModelValue(value)
}

initAddressStorageInDeliveryAddress()

onMounted(async () => {
  await fetchPoint()

  initBasketDelivery()
  //  Устанавливаем начальное состояние ДО
  await setInitStateOfDialog()
})

onUnmounted(() => resetDialogState())
</script>

<template>
  <the-dialog
    :model-value="modelValue"
    :max-width="960"
    padding="0"
    auto-width
    appear
    @update:model-value="changeDialogModelValue($event)"
  >
    <template
      v-if="stateDialogContent === STATE_CONTENT_ADDRESS_SYSTEM.NEW"
      #close
    >
      <the-button
        variant="transparent"
        icon="close-bigger"
        size="xs"
        radius="lg"
        background-color="var(--ui-white)"
        style="box-shadow: var(--ui-card-shadow)"
      />
    </template>

    <div class="address-system-dialog">
      <the-loader
        v-if="dialogState === STATE_DIALOG_ADDRESS_SYSTEM.LOADING"
        class="address-system-dialog__progress"
        color="var(--ui-primary)"
      />

      <address-system-dialog-error
        v-if="dialogState === STATE_DIALOG_ADDRESS_SYSTEM.ERROR"
      />

      <div v-if="isVisibleContent" class="address-system-dialog__content">
        <address-system-delivery
          :delivery-basket="deliveryBasket"
          :state-dialog-content="stateDialogContent"
          @on-change-basket-address="onChangeBasketAddress"
        />

        <address-system-map
          v-if="stateDialogContent === STATE_CONTENT_ADDRESS_SYSTEM.NEW"
          class="address-system-dialog__map"
          @on-click-restaurant="setSelectedRestaurant"
          @on-change-dialog-model-value="onChangeDialogModelValue"
        />
      </div>

      <dialog-redirect-other-city
        v-else
        :id="deliveryBasketId"
        :city-domain-prefix="deliveryBasket.city_domain_prefix"
        :delivery-method="deliveryBasket.delivery_method"
        :order-address="deliveryBasket.order_address"
        class="address-system-dialog__other-city"
        @close-dialog-redirect-city="refuseChangeOnOtherCity"
      />
    </div>
  </the-dialog>
</template>

<style lang="scss" scoped>
.address-system-dialog {
  display: flex;
  min-width: 510px;
  max-height: 692px;
  overflow: hidden;
  background-color: var(--ui-white);
  border-radius: 10px;

  &__other-city {
    width: 560px;
    height: 200px;
    margin: var(--dialog-padding);
  }

  &__content {
    display: flex;
    height: 624px;
    background-color: var(--ui-white);
  }

  &__map {
    position: relative;
    width: 550px !important;
    height: 100%;
  }

  &__progress {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    background-color: var(--ui-white);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: var(--ui-white);
    border-radius: 10px;
  }

  ::-webkit-scrollbar {
    width: 5px;
    background-color: var(--ui-white);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(var(--ui-secondary-rgb), 0.2);
    border-radius: 10px;
  }
}
</style>
